import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleize'
})
export class TitleizePipe implements PipeTransform {
  transform(input: string): string {
    return input.split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.substring(1).toLowerCase())
      .join(' ');
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/string/titleize.pipe.ts